module.exports = __webpack_public_path__ + "img/img_industries2.f1cdf7dd.jpg";